module.exports = __webpack_public_path__ + "static/media/bgtop-system-02.498a4b65.jpg";